import { JsonSchema, RowData, ToastInfo } from "../../../../types";
import { TOAST_MESSAGES } from "../../constants";
import * as XLSX from "xlsx";
import { validateHeaders } from "./validateHeaders";
import { getMappedData } from "./getMappedData";

export type COAExcelRow = (string | number | boolean | null | undefined)[];

export const parseExcelFile = async (
  file: File,
  schema: JsonSchema,
  metaData: {
    store_id: string;
    company_id: string;
    enterprise_id: string;
  },
  setupName: string,
): Promise<{
  data: RowData[];
  fileParseError?: ToastInfo;
}> => {
  try {
    const workbook = XLSX.read(await file.arrayBuffer(), {
      type: "array",
    });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const sheetName = workbook.SheetNames[0];

    if (sheetName !== setupName) {
      return {
        data: [],
        fileParseError: TOAST_MESSAGES.SHEET_NAME_MISMATCH(setupName),
      };
    }

    const jsonData = XLSX.utils.sheet_to_json<RowData>(sheet);
    const rows = XLSX.utils.sheet_to_json<COAExcelRow>(sheet, { header: 1 });
    const headerError = validateHeaders(rows[0] as string[], schema);

    if (headerError) {
      return {
        data: [],
        fileParseError: headerError,
      };
    }

    if (!jsonData.length) {
      return {
        data: [],
        fileParseError: TOAST_MESSAGES.EMPTY_FILE(),
      };
    }

    const mappedData = getMappedData(jsonData, schema, metaData);

    return { data: mappedData };
  } catch {
    return {
      data: [],
      fileParseError: TOAST_MESSAGES.FILE_PARSE_ERROR(),
    };
  }
};
